import { useNavigate } from "@tanstack/react-router";
import { Plus, Tag01 } from "@untitledui/icons";
import { EmptyState } from "@/components/application/empty-state/empty-state";
import { Button } from "@/components/base/buttons/button";
import { useScopedUrl } from "@/hooks/use-scoped-url";

export function NoCohortsEmptyState() {
  const navigate = useNavigate();
  const scopedUrl = useScopedUrl();

  return (
    <EmptyState size="sm" className="px-4 py-6">
      <EmptyState.FeaturedIcon icon={Tag01} color="gray" />
      <EmptyState.Content>
        <EmptyState.Title>No cohorts yet</EmptyState.Title>
        <EmptyState.Description>Create a cohort to use it in this rule</EmptyState.Description>
      </EmptyState.Content>
      <EmptyState.Footer>
        <Button
          size="sm"
          color="link-color"
          iconLeading={Plus}
          onClick={() => navigate({ to: `${scopedUrl}/creators/cohorts`, search: { manageCohorts: true } })}
        >
          Create cohort
        </Button>
      </EmptyState.Footer>
    </EmptyState>
  );
}
